import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { GameVM } from '../../core/game.service';
import { AnalyticsDirective } from '../../core/analytics/analytics.directive';
import { ImageLoaderComponent } from '../image-loader/image-loader.component';
import { DeviceService } from '@gains-com/ui-angular';

@Component({
  selector: 'app-game-card',
  imports: [MatButton, RouterLink, AnalyticsDirective, ImageLoaderComponent],
  templateUrl: './game-card.component.html',
  styleUrl: './game-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardComponent {

  protected readonly device = inject(DeviceService);

  private static readonly NEW_GAME_THRESHOLD_DAYS = 14;

  game = input.required<GameVM>();
  analyticsPageArea = input.required<string>();
  analyticsEventSource = input<string>();

  click = output<void>();

  isNew = computed(() => {
    const game = this.game();
    if (!game?.created_at) return false;

    const createdDate = new Date(game.created_at);
    const thresholdDate = new Date();
    thresholdDate.setDate(
      thresholdDate.getDate() - GameCardComponent.NEW_GAME_THRESHOLD_DAYS
    );
    return createdDate > thresholdDate;
  });
}
